var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageError"},[_c('section',{staticClass:"page"},[_c('div',{staticClass:"error"},[_c('h1',[_vm._v("Sorry, this page does not exist.")]),_c('p',[_vm._v(" Return to "),_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}},[_vm._v("Dashboard")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }